import BotIcon from '@/assets/images/rever-store/Icons/BotIcon'
import BoxesIcon from '@/assets/images/rever-store/Icons/BoxesIcon'
import LocationIcon from '@/assets/images/rever-store/Icons/LocationIcon'
import { MarketplaceIcon } from '@/assets/images/rever-store/Icons/MarketplaceIcon'
import MeasureIcon from '@/assets/images/rever-store/Icons/MeasureIcon'
import SecureIcon from '@/assets/images/rever-store/Icons/SecureIcon'

const Chatbot = () => {
  return (
    <>
      <div className="flex h-full flex-col text-left">
        <div className="flex size-10 items-center justify-center text-blue-500 transition-all duration-300 group-hover:-rotate-3 group-hover:scale-125">
          <BotIcon />
        </div>
        <p className="mt-2 text-lg font-semibold leading-5">
          Minimize Interaction With
          <br />
          <span className=" text-blue-500">Smart</span> AI Shopping{' '}
          <span className=" text-blue-500">Chatbot</span>
        </p>
      </div>
    </>
  )
}
const Marketplaces = () => {
  return (
    <>
      <div className="flex h-full flex-col text-left">
        <div className="flex size-10 items-center justify-center text-green-400 transition-all duration-300 group-hover:-rotate-3 group-hover:scale-125">
          <MarketplaceIcon />
        </div>
        <p className="mt-2 text-lg font-semibold leading-5">
          Go <span className="text-green-400">Multichannel</span> With
          <br /> Marketplace Integrations{' '}
        </p>
      </div>
    </>
  )
}
const Suggestions = () => {
  return (
    <>
      <div className="flex h-full flex-col text-left">
        <div className="flex size-10 items-center justify-center text-orange-500 transition-all duration-300 group-hover:-rotate-3 group-hover:scale-125">
          <MeasureIcon />
        </div>
        <p className="mt-2 text-lg font-semibold leading-5">
          Offer{' '}
          <span className="bg-gradient-to-r from-orange-500 via-pink-500 to-emerald-500 bg-clip-text text-transparent">
            Size Suggestions
          </span>
          <br />
          To Minimize Preventable Returns
        </p>
      </div>
    </>
  )
}

const Warranty = () => {
  return (
    <>
      <div className="flex h-full flex-col text-left">
        <div className="flex size-10 items-center justify-center text-teal-400 transition-all duration-300 group-hover:-rotate-3 group-hover:scale-125">
          <SecureIcon />
        </div>
        <p className="mt-2 text-lg font-semibold leading-5">
          Net Sales Warranty: Replace And Refund,{' '}
          <span className="text-teal-400">Risk-Free</span>.
        </p>
      </div>
    </>
  )
}

const Shipments = () => {
  return (
    <>
      <div className="flex h-full flex-col text-left">
        <div className="flex size-10 items-center justify-center text-rose-500 transition-all duration-300 group-hover:-rotate-3 group-hover:scale-125">
          <BoxesIcon />
        </div>
        <p className="mt-2 text-lg font-semibold leading-5">
          Shipments Never Felt So
          <br />
          <span className="text-rose-500">Close</span>.{' '}
          <span className="text-rose-500">Easy</span>.{' '}
          <span className="text-rose-500">Fast</span>.
        </p>
      </div>
    </>
  )
}

const Tracking = () => {
  return (
    <>
      <div className="flex h-full flex-col text-left">
        <div className="mb-1 flex size-8 items-center justify-center text-purple-500 transition-all duration-300 group-hover:-rotate-3 group-hover:scale-125">
          <LocationIcon />
        </div>
        <p className="mt-2 text-lg font-semibold leading-5">
          Order Tracking: No More <br />
          {'"'}
          <span className="text-purple-500">Where Is My Order?</span>
          {'"'}
        </p>
      </div>
    </>
  )
}

export { Chatbot, Marketplaces, Suggestions, Warranty, Shipments, Tracking }
